import React, { useEffect, useState } from 'react';
import { Button, Card, Flex, Heading, Loader } from '@aws-amplify/ui-react';
import FactsSheetProfileCard from './FactsSheetProfileCard';
import FactsSheetDetailsAdd from './FactsSheetAddPage';
import FactsSheetCard from './FactsSheetCard';

export default function FactsSheetPage() {
  const [showFactsSheetDetailsAdd, setShowFactsSheetDetailsAdd] =
    useState(false);
  const [loading, setLoading] = useState(true);

  const handleButtonClick = () => {
    setShowFactsSheetDetailsAdd((prevState) => !prevState);
  };
  const handleClose = () => {
    setShowFactsSheetDetailsAdd(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      {loading ? (
        <Flex justifyContent="center" alignItems="center" height="100vh">
          <Loader />
        </Flex>
      ) : (
        <Flex
          direction="column"
          padding="32px"
          backgroundColor="rgba(250,250,250,1)"
        >
          <Heading level="1">Facts Sheet</Heading>
          <FactsSheetProfileCard />
          <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Button variation="primary" onClick={handleButtonClick}>
              + New Custom Section
            </Button>
          </Flex>
          {showFactsSheetDetailsAdd && (
            <Card variation="elevated" padding="small" margin="small">
              <FactsSheetDetailsAdd onClose={handleClose} />
            </Card>
          )}
          <FactsSheetCard />
        </Flex>
      )}
    </>
  );
}
